const conveyor = new URL('../../icons/conveyor.png', import.meta.url).href

export default {
  type: 'Conveyor',
  description: 'Conveyor',
  icon: conveyor,
  group: 'CCS',
  model: {
    type: 'Conveyor',
    left: 100,
    top: 100,
    width: 100,
    height: 20,
    lineWidth: 1,
    strokeStyle: 'black',
    rollWidth: 12
  }
}
